<div mat-dialog-title>
  <su-headline h="h3" skin="primary">{{
    'user.request.permissions.assignment.end_dialog.title' | translate
  }}</su-headline>
</div>

<div mat-dialog-content>
  <form [formGroup]="form">
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"></formly-form>
  </form>
  <div>
    <p>
      {{
        'user.request.permissions.assignment.end_dialog.description'
          | translate
      }}
    </p>
  </div>
</div>
<div mat-dialog-actions>
  <su-button
    skin="secondary"
    [label]="'shared.cancel' | translate"
    mat-dialog-close></su-button>

  <su-button
    skin="primary"
    [label]="
      'user.request.permissions.assignment.end_dialog.confirm' | translate
    "
    (onClick)="dialogRef.close(true)"></su-button>
</div>
